import useOngoingOrder from '../../../../hooks/context/useOngoingOrder';
import { WithClassname } from '../../../../types';
import React from 'react';
import { ClockCircleOutlined } from '@ant-design/icons';
import str from '../../../../services/utils/Stringable';

export default function OrderTimeDetails({ className }: WithClassname) {
  const { orderData, timeLabel } = useOngoingOrder();

  return (
    Boolean(orderData.method) && (
      <div className={className}>
        <div className="flex gap-sm">
          <ClockCircleOutlined />
          <div>
            <h6 className="uppercase">Food ready time:</h6>
            <p>
              {str(orderData.method).ucfirst().toString()} {timeLabel}
            </p>
          </div>
        </div>
      </div>
    )
  );
}
